<div class="p-dialog-header px-0">
  <div class="p-dialog-title">
    <div class="flex gap-spacing-xs align-items-center">
      <span class="title-small-bold text-primary-color">Add Payout Adjustment for Ride</span>
      <span class="text-light-color body-medium-medium">#{{ config.data.id }}</span>
    </div>
  </div>
  <div class="p-dialog-header-icons">
    <app-button
      (btnClick)="ref.close()"
      [iconOnlyButton]="true"
      icon="icon-x"
      sizeClass="p-button-sm"
      severity="secondary"
      [textButton]="true"></app-button>
  </div>
</div>

<div class="content p-spacing-xl border-1 border-neutral-base-primary-border border-round-lg table-bg-hover-bg">
  <form
    #payoutForm="ngForm"
    class="flex flex-column gap-spacing-xl">
    <div class="form-group">
      <label
        class="input-label label-large-medium text-secondary-color mb-spacing-default flex gap-spacing-default align-items-center"
        for="payoutAdjustment"
        >Payout Adjustment</label
      >
      <div class="k-input-wrapper">
        <em class="left-icon icon-currency-dollar"></em>
        <p-inputNumber
          class="w-full p-inputtext-sm"
          #payoutAdjustment="ngModel"
          ngModel
          name="payoutAdjustment"
          inputId="payoutAdjustment"
          mode="decimal"
          placeholder="0.00"
          required
          [style]="{ width: '100%' }"
          [maxFractionDigits]="2" />
      </div>
      @if (payoutAdjustment.dirty && payoutAdjustment.errors && payoutAdjustment.errors["required"]) {
        <small class="input-helper-text label-medium-regular text-danger-color">This field is required.</small>
      }
    </div>

    <div class="form-group flex flex-column gap-spacing-xs">
      <label
        class="input-label flex flex-column gap-spacing-default body-medium-medium"
        for="reasonInput"
        >Reason
        <span class="body-small-medium text-caption-color">The reason for why you are adding this adjustment.</span>
      </label>
      <p-autoComplete
        #reasonInput="ngModel"
        #autoCompleteRef
        [(ngModel)]="reason"
        name="reason"
        required
        [suggestions]="filteredSuggestions"
        (completeMethod)="filterSuggestions($event, autoCompleteRef)"
        (onFocus)="filterSuggestions($event, autoCompleteRef)"
        [showEmptyMessage]="false"
        appendTo="body"
        [style]="{ width: '100%' }"
        [inputStyle]="{ paddingBottom: '72px', height: '100px' }"
        placeholder="Select or enter a reason." />
      @if (reasonInput.dirty && reasonInput.errors && reasonInput.errors["required"]) {
        <small class="input-helper-text label-medium-regular text-danger-color">This field is required.</small>
      }
    </div>
  </form>
</div>

<div class="footer py-spacing-2xl px-0 gap-spacing-xl flex justify-content-end gap-spacing-xl">
  <app-button
    label="Close"
    (btnClick)="ref.close()"
    sizeClass="p-button-md"
    severity="secondary"></app-button>
  <app-button
    [isLoading]="loading"
    [iconStart]="loading ? 'icon-spinner-gap' : ''"
    [disabled]="!payoutForm.valid || loading || reasonInput.value?.trim().length <= 0"
    label="Add Payout"
    (btnClick)="confirmAction()"
    sizeClass="p-button-md"
    severity="primary"></app-button>
</div>
